<template>
  <div class="card-game" @click="goToGame">
    <div class="card-game__cover">
      <div class="card-game__status" :class="{'card-game__status--live': game.status === 'LIVE'}">{{$t(`cardGame.status.${game.status}`)}}</div>
      <img :src="getUrlPicture(game.picture)" alt="" v-if="game.picture != ''">
      <img src="@/assets/placeholder-ff21.jpg" alt="" v-else>
    </div>
    <div class="card-game__content">
      <h3 class="card-game__content__stadium">{{$t("cardGame.stadium")}} {{game.stadium}}</h3>
      <h2 class="card-game__content__title">{{game.teamLocal.name}} vs {{game.teamVisitor.name}}</h2>
      <p class="card-game__content__description">{{game.description}}</p>
      <div class="card-game__content__action" v-if="game.status === 'LIVE'">
        <h3>{{$t("cardGame.goToGame")}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    game: Object
  },
  methods: {
    getUrlPicture(picture) {
      return `${process.env.VUE_APP_CDN_URL_GAME_PICTURES}${picture}`
    },
    goToGame() {
      if (this.game.status === 'LIVE') {
        this.$store.dispatch("setGameSelect", this.game)
        // Ticketera
        if (this.game.localPaid && this.game.visitorPaid && !this.game.localGrants && !this.game.visitorGrants ) {
          this.$router.push(`/game/${this.game.id}/ticketera`)
        } else if (this.game.localGrants && this.game.visitorGrants) {
          this.$router.push(`/game/${this.game.id}/team`)
        } else if (this.game.localGrants) {
          this.$router.push(`/game/${this.game.id}/${this.game.teamLocal.id}/avatar`)
        } else if (this.game.visitorGrants) {
          this.$router.push(`/game/${this.game.id}/${this.game.teamVisitor.id}/avatar`)
        } else {
          this.$router.push(`/game/${this.game.id}/team`)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';
.card-game {
  border-radius: $redondeado;
  overflow: hidden;
  margin: $margin-small 0;
  width: 100%;
  flex: 1 0 47%;
  cursor: pointer;

  @media (min-width: $break-lg) {
    position: relative;
    max-height: 400px;

    &__cover {
      padding-bottom: 56.25%!important;
    }
  }

  &__cover {
    width: 100%;
    height: 0;
    padding-bottom: 42.85%;
    background-color: $graybg;
    position: relative;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
    }

    .card-game__status {
      padding: ($margin-milli / 2) $margin-milli;
      color: $white;
      background: $blue;
      border-radius: $redondeado;
      font-weight: 700;
      font-style: italic;
      text-transform: uppercase;
      position: absolute;
      top: $margin-milli;
      right: $margin-milli;
      font-size: map-get($fontSizes, milli);
      z-index: 1;

      &--live {
        background: $violet;
      }
    }
  }

  &__content {
    background: $white;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: $margin-base;
    border: 1px solid transparent;
    border-radius: $redondeado;
    margin-top: -$margin-milli / 2;
    position: relative;

    @media (min-width: $break-lg) {
      border-radius: $margin-base $margin-base $margin-milli / 2 $margin-milli / 2;
      margin-top: -$margin-base;
      position: absolute;
      bottom: 0;
      width: 100%;
      background-color: #ffffffde;
    }


    &__title {
      @include font-settings(mega, mega);
      color: $darkblue;
      margin-bottom: $margin-milli / 2;
      font-weight: 700;
    }

    &__stadium {
      @include font-settings(milli, base);
      color: $lightblue;
      font-weight: 700;
      font-style: italic;
    }

    &__description {
      @include font-settings(base, base);
      color: $gray;
      font-weight: 600;
      margin-bottom: $margin-base;
    }

    &__action {
      @include font-settings(milli, base);
      margin-top: $margin-small;
      text-transform: uppercase;
      color: $violet;
      width: 100%;
      text-align: right;
    }
  }
}

.home--games__list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0!important;
}

.home--games,
.home--games__list {
  padding: 80px $margin-base;
  justify-content: flex-start;

  @media (min-width: $break-lg) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 80px 104px;

    .card-game {
      margin: $margin-small;
      
      &:first-child {
        max-width: 984px;
        position: relative;
        flex: 1 1 auto;

        .card-game__content {
          position: absolute;
          bottom: 0;
          width: 100%;
          border-radius: $margin-base $margin-base $margin-milli / 2 $margin-milli / 2;
          background-color: #ffffffde;
          padding-right: 160px;

          &__title {
            @include font-settings(semitera, mega);
            font-weight: 900;
          }

          &__stadium {
            @include font-settings(kilo, mega);
            font-weight: 900;
          }

          &__description {
            @include font-settings(mega, mega);
          }

          &__action {
            position: absolute;
            right: $margin-base;
            bottom: $margin-base;
          }
        }
      }
    }
  }
}
</style>